module.exports = __webpack_public_path__ + "img/youtube.d03a1af2.svg";